import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [성능/운영>요약] 구간별 응답시간 성능위젯 - Agent 리스트 조회
   * @author kimjy
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getE2EAgentList(params) {
    return axios.post(`${baseUrl}/performance/summary/e2e/get-agent-list.do`, params);
  },
  /**
   * [성능/운영>요약] E2E 성능위젯 정보 조회
   * @author kimjy
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getE2ESummaryRscRsltList(params) {
    return axios.post(`${baseUrl}/performance/summary/e2e/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-list.do`, params);
  },
  /**
   * [성능/운영>요약] E2E 성능위젯 정보 조회 (후면)
   * @author kimjy
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getE2ESummaryRscRsltBackList(params) {
    return axios.post(`${baseUrl}/performance/summary/e2e/get-${params.summaryWidgetKey.toLowerCase()}-rsc-rslt-back-list.do`, params);
  },
  /**
   * [성능/운영>요약] E2E 구성정보 위젯 정보 조회
   * @author jeee12
   * @param  {Object} params transactionId, serviceId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getE2EConfigurationInfo(params) {
    return axios.get(`${baseUrl}/performance/summary/e2e/get-configuration-info.do`, { params });
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/e2e/e2e-info.js